import React from 'react';
import {IFormDataProviderAPIContext} from '../@interfaces/contexts/IFormDataProviderAPIContext';

export const FormDataProviderAPIContext = React.createContext<IFormDataProviderAPIContext | null>(null);
